export const KYC_STATUS_ONE = 1
export const KYC_STATUS_REJECTED = 2
export const KYC_STATUS_PENDING = 3
export const KYC_STATUS_APPROVED = 5
